import React from 'react';

export const landingPageFAQs = [
  {
    question: 'What factors affect your borrowing capacity?',
    answer: (
      <React.Fragment>
        <p>The factors that affect how much you can borrow include:</p>
        <ul>
          <li>Your income</li>
          <li>Your expenses</li>
          <li>Existing debts, including credit card limits</li>
          <li>Credit history</li>
          <li>Assets you own (e.g. vehicles, superannuation, investments)</li>
          <li>The amount of your deposit</li>
          <li>The value of the property that you own or plan to buy</li>
          <li>The length, interest rate and type of loan</li>
        </ul>
        <p>
          By having an idea of what you can borrow, you can focus your property search on homes that are within your price range.
        </p>
      </React.Fragment>
    )
  },
  {
    question: 'What is a home loan comparison rate and how is it calculated?',
    answer: (
      <React.Fragment>
        <p>
          A comparison rate is a rate that helps you outline the total cost of a loan. It is a single annual percentage figure that combines the loan interest rate plus selected fees and charges. The comparison rate allows you to compare loans from different home loan lenders to understand how much it will truly cost you.
        </p>
        <p>
          Lenders are required by law to calculate and publish the comparison rate for their loans and the assumptions / inputs are as follows:
        </p>
        <ul>
          <li>Loan amount of $150,000</li>
          <li>Loan term of 25 years</li>
          <li>Repayment frequency</li>
          <li>Interest rate</li>
          <li>Monthly account fee (if any)</li>
          <li>Annual fee (if any)</li>
          <li>Establishment fee (if any)</li>
          <li>Valuation fee (if any)</li>
          <li>Mortgage documentation fee (if any)</li>
          <li>Settlement fee</li>
        </ul>
      </React.Fragment>
    )
  },
  {
    question: 'How is interest calculated on your home loan?',
    answer: (
      <p>
        We calculate interest on a daily basis by taking the outstanding balance of your home loan. We then charge interest at the end of each month.
      </p>
    )
  },
  {
    question: 'How much deposit do you need for a home loan?',
    answer: (
      <React.Fragment>
        <p>
          Yard can lend up to 95% of the property’s value with Lenders Mortgage Insurance. We will expect that you will have additional funds to cover any upfront costs that are associated with a property transaction (e.g. stamp duty, legal fees, etc).
        </p>
        <p>
          To avoid paying Lenders Mortgage Insurance (LMI), you will need to have a 20% deposit in most cases.
        </p>
      </React.Fragment>
    )
  }
]

export const borrowingCapacityFaqs = [
  {
    question: 'What type of loans does Yard provide?',
    answer: (<p>We can help you purchase or refinance a property. We can offer loans for renovations, construction or for when you’re investing through your SMSF. We also provide bridging loans if you need to buy before going through the process of selling an existing property.</p>)
  },
  {
    question: 'What size home loans does Yard provide?',
    answer: (<p>The minimum loan size you can apply for is $150,000, whilst the maximum loan size is $5 million.</p>)
  },
  {
    question: 'What is the Loan to Value Ratio (LVR) that Yard can lend up to?',
    answer: (<p>The Loan to Value Ratio (LVR) is the loan amount as a percentage of the value of your property. To calculate it, you divide the loan amount by your property’s value. Yard can lend up to 95% LVR for owner-occupied properties and up to 90% LVR for investment properties. For loans with LVR above 80%, Lenders Mortgage Insurance applies.</p>)
  },
  {
    question: 'Does Yard provide loans to self-employed customers?',
    answer: (<p>Yes. Yard specialises in home loans for self-employed borrowers and business owners with as little as 6 months of ABN registration. We offer both standard and alternative income verification options, including for borrowers who may not have up-to-date tax returns or standard financial documents. All loans are subject to eligibility and lending criteria.</p>)
  }
]


export const homeDepositCalculatorsFaq = [
  {
    question: 'What are the upfront costs for buying a property?',
    answer: (<p>The two biggest hurdles in buying a property include saving for a home loan deposit and paying stamp duty. Other costs that you should also budget for include things like Lenders Mortgage Insurance (if you don't have a 20% deposit), conveyancing fees, building & pest inspection costs, home insurance, removalist and moving costs.</p>)
  },
  {
    question: 'What is a home loan deposit?',
    answer: (<p>The home loan deposit is the contribution that you're making towards the purchase of your property. Having this deposit will help you to secure a loan with a lender. It shows the lender that you are able to save, gives them some security and reduces their risk. You can put a deposit down for any amount that is at least 5% of the property’s value.</p>)
  },
  {
    question: 'Is there a minimum deposit for a home loan?',
    answer: (<p>Yard can consider loans with a maximum of 95% LVR for owner-occupied properties and 90% for investment properties. Where the LVR exceeds 80%, Lenders Mortgage Insurance applies.</p>)
  },
  {
    question: 'What is LVR (Loan-to-Value Ratio)?',
    answer: (<p>Your LVR is calculated by dividing the amount of your home loan by the purchase price or appraised value of the property. The lower the LVR, the lower the risk to the lender. Many lenders will consider an LVR over 80% of the property value to be a higher risk, and you could have to pay LMI.</p>)
  },
  {
    question: 'Can I buy a property without deposit?',
    answer: (<p>You generally cannot buy a home without a deposit, however, there are some exceptions. You can have your parents or a relative guarantee your loan, by using their property as security. This is called a guarantor loan. Another way you may be able to buy a property without a deposit is if you already own a property. In this case, you can also use the equity in your existing home (i.e. the portion of the property you actually own) as a deposit or security for a new home loan.</p>)
  }
]

export const homeEquityCalculatorsFaq = [
  {
    question: 'What is home equity?',
    answer: (<p>Home equity is the portion of your property that you own outright, or the difference between the market value of your property and your current home loan balance. If property prices have gone up and you have taken a principal & interest home loan that you have paid down over time, it is likely that you have increased the available equity in your home.</p>)
  },
  {
    question: 'What can I use home equity for?',
    answer: (<p>Once you have built up some equity, you can refinance to access it. There are a few reasons you may want to access the equity in your property. The first would be to get cash out, for example to fund renovations or buy a car. Another reason you might want to access your equity is to build your property portfolio by purchasing a second property. Using the equity from your current property, you may be able to pay a deposit and the upfront costs for the purchase of another property.</p>)
  },
  {
    question: 'How much equity can I access?',
    answer: (<p>You can use our equity calculator to estimate the available equity in your property. Typically, you can access up to 80% of the value of the property minus any outstanding home loan balance. If you are seeking to access more than 80% of the value of the property, Lenders Mortgage Insurance would apply.</p>)
  },
  {
    question: 'What does it cost to access equity?',
    answer: (<p>Accessing equity in your property typically involves the need for you to refinance. You need to investigate the costs associated with refinancing, e.g. application and valuation fees, settlement fees, etc. If you are accessing more than 80% of the value of the property, you should also factor Lenders Mortgage Insurance costs. Last but not least, you should budget for the required repayments on your new home loan amount.</p>)
  }
]

export const mortgageRepaymentFaqs = [
  {
    question: 'What size home loans does Yard provide?',
    answer: (<p>The minimum loan size you can apply for is $150,000, whilst the maximum loan size is $5 million.</p>)
  },
  {
    question: 'How long can I borrow money from Yard to finance my home?',
    answer: (<p>We can lend you funds for a loan term period between 2 and 40 years.</p>)
  },
  {
    question: 'What type of interest rates and repayments do you offer?',
    answer: (<p>We offer variable and fixed interest rates on our home loans. We provide 1, 2, 3 and 5-year fixed rate loans. You may select to repay principal and interest from the start or apply to have a limited period making just interest repayments. Our maximum interest only period is 10 years.</p>)
  },
  {
    question: 'How frequently can I repay my loan with Yard?',
    answer: (<p>Yard provides the option for monthly, fortnightly or weekly repayments. We can setup automatic loan repayments with a periodic debit linked to your Yard offset account or another bank account.</p>)
  }
]

export const offsetCalculatorFaqs = [
  {
    question: 'What type of interest rates and repayments do you offer?',
    answer: (<p>We offer variable and fixed interest rates on our home loans. We provide 1, 2, 3 and 5-year fixed rate loans. You may select to repay principal and interest from the start or apply to have a limited period making just interest repayments. Our maximum interest only period is 5 years.</p>)
  },
  {
    question: 'Can I have an offset account with a fixed interest rate?',
    answer: (<p>Yard offers offset accounts only with variable rate loans.</p>)
  },
  {
    question: 'Can I have multiple offset accounts?',
    answer: (<p>Yes! Yard provides up to five loan splits. You can set up an offset account against each variable rate loan split.</p>)
  },
  {
    question: 'When can I set up an offset account?',
    answer: (<p>You can advise us that you require an offset account during your initial application and we will set up your offset account at settlement. However, you can also set up an offset account at any point after settlement during your loan term.</p>)
  },
  {
    question: 'How do loan repayments work with an offset account?',
    answer: (<p>You can select for your loan repayments to be deducted from your offset account. However, you can also choose to continue making repayments from a different account, e.g. via direct debit.</p>)
  }
]

export const refinanceCalculatorFaqs = [
  {
    question: 'Why would I look to refinance my home loan?',
    answer: (<p>There's a range of reasons you may consider refinancing. These include saving money on mortgage repayments by obtaining a better interest rate, consolidating your debts, obtaining new loan features or accessing the equity that you may have built up within your property.</p>)
  },
  {
    question: 'How long does the refinance process take?',
    answer: (<p>If you are able to provide the information Yard requires promptly, we can approve and settle your loan within 4 weeks.</p>)
  },
  {
    question: 'What are the costs associated with refinancing?',
    answer: (<p>You need to assess the upfront costs with your new lender (e.g. application or valuation fees), the costs to leave your existing lender (e.g. discharge fees) as well as the relevant Government mortgage registration and de-registration fees.</p>)
  },
  {
    question: 'What supporting documents are required to assess my refinance application?',
    answer: (<p>We obtain information such as personal identification, proof of income, assets and liabilities information. Other documentation might include details of your current mortgage and evidence you have kept up repayments.</p>)
  }
]

export const stampDutyFaqs = [
  {
    question: 'What is stamp duty (transfer duty)?',
    answer: (<p>Stamp duty is a state or territory government tax that applies to the purchase of a property which you, the buyer, pays. Stamp duty applies when you purchase a property to use as your own home, an investment property or vacant land. Some state and territory governments might refer to 'stamp duty' as 'transfer duty'.</p>)
  },
  {
    question: 'How is stamp duty calculated?',
    answer: (<p>Stamp duty amounts vary by state, the value of the property, whether you are a first home buyer or not, and the use of property (owner-occupied vs. investment). To obtain an estimate of stamp duty applicable to you, you can use our handy stamp duty calculator.</p>)
  },
  {
    question: 'Are there stamp duty exemptions?',
    answer: (<p>Depending on the state you are purchasing, you might be exempt from paying stamp duty (if the property falls under a certain value) or qualify for a concession to pay reduced stamp duty. For example, in certain states, first home buyers are exempt from paying stamp duty up to a certain property value threshold. You might also be eligible for other grants and concessions, such as  the First Home Owner Grant, which is also managed at state and territory level.</p>)
  },
  {
    question: 'When is stamp duty payable?',
    answer: (<p>Timing of when you need to pay stamp duty varies by state. For example, in NSW you must pay stamp duty within three months of signing a contract for the sale or transfer for an established property. For owner-occupied off-the-plan purchases, you may be able to defer your transfer duty liability for up to 12 months.</p>)
  }
]

